import * as React from 'react';
import type { ReactNode } from 'react';

interface ListProps<T> extends Pick<React.HTMLAttributes<HTMLUListElement>, 'role' | 'tabIndex' | 'onKeyDown'> {
    items: ReadonlyArray<T>;
    renderItem: (item: T, index: number) => ReactNode;
    className?: string;
}

const ListComponent = <TItem,>(props: ListProps<TItem>, ref?: React.Ref<HTMLUListElement>) => {
    const { items, renderItem, className, ...otherProps } = props;

    return (
        <ul ref={ref} className={className} {...otherProps}>
            {items.map((item, index) => renderItem(item, index))}
        </ul>
    );
};

type GenericForwardRefList = <TItem>(
    props: ListProps<TItem> & { ref?: React.Ref<HTMLUListElement> }
) => React.ReactElement;

export const List = React.forwardRef(ListComponent) as GenericForwardRefList;
